import $ from 'jquery';
import common from '../base/common';

class Scroller{


    constructor(){

        this.scrollEvents = 'scroll.pagination mousewheel.pagination DOMMouseScroll.pagination touchmove.pagination';
        this.preventDefault = this.preventDefault.bind(this);
        this.parallax = this.parallax.bind(this);
        this.factor = common.screen.height * -0.5;

    }

    enable(change){

        if(change)
            this.factor = 0;

        common.$window.off(this.scrollEvents, this.preventDefault);
        common.$window.on(this.scrollEvents, this.parallax);
    }

    disable(change){

        if(change)
            this.factor = 0;

        common.$window.on(this.scrollEvents, this.preventDefault);
        common.$window.off(this.scrollEvents, this.parallax);
    }

    preventDefault(e){

        e.preventDefault();

    }

    parallax(){


        if(common.$window.scrollTop() < common.screen.height){

            TweenMax.set($('.SectionSlider__Item.__active .SectionSlider__ItemBg'), {x: '-50%', y: this.factor + common.$window.scrollTop() * 0.2})

        }

    }

}

export default new Scroller();


// WEBPACK FOOTER //
// ./js/components/scroller.js